import React from "react";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import {selectGetVoucher} from "../../redux/slices/appSlice";
import {FaCopy} from "react-icons/fa";

export const Voucher: React.FC = () => {
    const selGetVoucher = useSelector(selectGetVoucher);
    const handleCopy = () => {
        navigator.clipboard.writeText(selGetVoucher?.data || "").then(() => {
            toast.success("Đã sao chép mã Coupon", {type: "success"});
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    }

    return <div className={"bg-[#192D52] px-[50px] rounded-[24px] h-[576px]"} id={"voucher"}>
        <div className={"h-full flex flex-col items-center justify-center"}>
            <h1 className={"xl:text-[1.5rem] font-[600] text-white text-center"}>Mã học thử Betia:</h1>
            <div className={"bg-[#FFBF00] relative flex flex-col justify-center items-center mt-[1rem] mb-[.6rem] w-full max-w-[80%]" +
                " xl:max-w-[420px] h-[50px]"}>
                <span className={"font-bold text-[1.25rem] xl:text-[1.5rem] text-[#105296]"}>{selGetVoucher?.data}</span>
                <FaCopy className={"text-[#105296] absolute right-[1rem] cursor-pointer text-[1.25rem]"} onClick={handleCopy}/>
            </div>
            {(selGetVoucher && selGetVoucher?.code != 0) && <p className={"xl:text-[1rem] font-bold text-[#F63B2C]"}>{selGetVoucher.message}</p>}
        </div>
    </div>
}
